import React, { useState } from 'react';
import './style.css';
import { Sidebar, Menu, MenuItem, useProSidebar } from 'react-pro-sidebar';
import { Box, IconButton, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import PieChartOutlineOutlinedIcon from '@mui/icons-material/PieChartOutlineOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import Colors from '../../Constant/Colors';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
const Sidebartab = () => {
  const { collapseSidebar } = useProSidebar();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const logout = () =>{
    navigate('/login');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('User_Email');
    localStorage.removeItem('Role');
    localStorage.removeItem('user_id');
    window.location.reload();
   }
  return (
    <Box
      sx={{
        '& .pro-sidebar-inner': {
          background: `${Colors.primary} !important`,
        },
        '& .pro-icon-wrapper': {
          backgroundColor: 'transparent !important',
        },
        '& .pro-inner-item': {
          padding: '5px 35px 5px 20px !important',
        },
        '& .pro-inner-item:hover': {
          color: '#868dfb !important',
        },
        '& .pro-menu-item.active': {
          color: '#6870fa !important',
        },
      }}>
      <Sidebar backgroundColor={'#d5fff1'} style={{}}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => {
              setIsCollapsed(!isCollapsed);
              collapseSidebar();
            }}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: '10px 0 20px 0',
              color: Colors.darkpurple,
            }}>
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px">
                <Typography variant="h7" color={Colors.gray}>
                  Admin Dashboard
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                {/* <img
                  width="100px"
                  height="100px"
                  src={'../../../public/Logo.png'}
                  style={{ cursor: "pointer", borderRadius: "50%" ,backgroundColor:'black'}}
                /> */}
                <img
                  alt="Hardik Panwar"
                  src={require('../../assets/Images/admin.jpg')}
                  style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                  }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h6"
                  color={Colors.darkpurple}
                  fontWeight="bold"
                  sx={{ m: '10px 0 0 0' }}>
                  Hardik Panwar
                </Typography>
                {/* <Typography variant="h7" color={Colors.gray}>
                  Admin
                </Typography> */}
              </Box>
            </Box>
          )}

          <Box>
            <MenuItem
              icon={<HomeOutlinedIcon />}
              component={<Link to="/admin/dashboard/:id" />}
              style={{
                color: Colors.primary,
                root: {
                  '&:hover': {
                    backgroundColor: 'blue',
                  },
                },
                'MuiMenuItem-root :hover': {
                  backgroundColor: 'blue',
                },
              }}>
              <Typography>Dashboard</Typography>
            </MenuItem>
            {/* <Item
              title="Dashboard"
              to="/admin/dashboard"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}

            <Typography
              variant="h6"
              color={Colors.darkpurple}
              sx={{ m: '15px 0px 5px 20px' }}
              alignSelf={'center'}
              fontWeight="bold">
              Data
            </Typography>
            <MenuItem
              icon={<PeopleOutlinedIcon />}
              component={<Link to="/admin/manage-designer" />}
              style={{
                color: Colors.primary,
              }}>
              <Typography>Manage Designer</Typography>
            </MenuItem>

            <MenuItem
              icon={<PeopleOutlinedIcon />}
              component={<Link to="/admin/manage-recruiter" />}
              style={{
                color: Colors.primary,
              }}>
              <Typography>Manage Recruiter</Typography>
            </MenuItem>

            <MenuItem
              icon={<ContactsOutlinedIcon />}
              component={<Link to="/admin/users-information" />}
              style={{
                color: Colors.primary,
              }}>
              <Typography>Users Information</Typography>
            </MenuItem>

            <MenuItem
              icon={<ReceiptOutlinedIcon />}
              component={<Link to="/admin/recruiter-pending-request" />}
              style={{
                color: Colors.primary,
              }}>
              <Typography>Pending requests</Typography>
            </MenuItem>

            <Typography
              variant="h6"
              color={Colors.darkpurple}
              sx={{ m: '15px 0 5px 0' }}
              paddingLeft={isCollapsed ? '10%' : '20px'}
              alignSelf={'center'}
              fontWeight="bold">
              Charts
            </Typography>

            <MenuItem
              icon={<BarChartOutlinedIcon />}
              component={<Link to="/admin/bar" />}
              style={{
                color: Colors.primary,
              }}>
              <Typography>Bar Chart</Typography>
            </MenuItem>

            <MenuItem
              icon={<PieChartOutlineOutlinedIcon />}
              component={<Link to="/admin/pie" />}
              style={{
                color: Colors.primary,
              }}>
              <Typography>Pie Chart</Typography>
            </MenuItem>
            {/* <MenuItem
            icon={<TimelineOutlinedIcon />}
            component={<Link to="/admin/line" />} 
            style={{
                color:Colors.primary
              }} >
               <Typography>Line Chart</Typography>
            </MenuItem> */}
            {/* <MenuItem
              icon={<MapOutlinedIcon />}
              component={<Link to="/admin/line-chart" />}
              style={{
                color: Colors.primary,
              }}>
              <Typography>Line Chart</Typography>
            </MenuItem> */}

            <Typography
              variant="h6"
              color={Colors.darkpurple}
              sx={{ m: '15px 0px 5px 0' }}
              paddingLeft={isCollapsed ? '15%' : '20px'}
              fontWeight="bold">
              Pages
            </Typography>
            {/* <MenuItem
            icon={<PersonOutlinedIcon />}
            component={<Link to="/admin/profile-form" />} 
            style={{
                color:Colors.primary
              }} >
               <Typography>Profile Form</Typography>
            </MenuItem> */}

            <MenuItem
              icon={<CalendarTodayOutlinedIcon />}
              component={<Link to="/admin/calendar" />}
              style={{
                color: Colors.primary,
              }}>
              <Typography>Calendar</Typography>
            </MenuItem>

            <MenuItem
              icon={<HelpOutlineOutlinedIcon />}
              component={<Link to="/admin/faq" />}
              style={{
                color: Colors.primary,
              }}>
              <Typography>FAQ Page</Typography>
            </MenuItem>

            <MenuItem
              icon={<LogoutIcon />}
              onClick={()=> logout()}
              style={{
                color: Colors.primary,
                marginTop: 30,
              }}>
              <Typography>Logout</Typography>
            </MenuItem>
          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default Sidebartab;
